import React from 'react';

const variants = {
  default: 'bg-primary/10 text-primary',
  secondary: 'bg-muted text-muted-foreground',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  info: 'bg-info/15 text-info',
  destructive: 'bg-destructive/15 text-destructive',
  outline: 'border border-border text-foreground'
};

const dotColors = {
  default: 'bg-primary',
  secondary: 'bg-muted-foreground',
  success: 'bg-success',
  warning: 'bg-warning',
  info: 'bg-info',
  destructive: 'bg-destructive',
  outline: 'bg-muted-foreground'
};

/**
 * One muted tone per state — no gradient pills. Pass `dot` for a leading
 * status dot instead of a filled background (useful in dense tables/lists).
 */
const Badge = ({ children, variant = 'default', dot = false, className = '', ...props }) => {
  if (dot) {
    return (
      <span className={`inline-flex items-center gap-1.5 text-xs font-medium text-foreground ${className}`} {...props}>
        <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]}`} />
        {children}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-semibold transition-colors ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
export { Badge };
